import classNames from "classnames";
import React, { ComponentProps } from "react";

import "./text-field.css";

type TextFieldProps = {
	isFullWidth?: boolean;
	ref?: React.Ref<HTMLInputElement>;
} & ComponentProps<"input">;

export const TextField = ({ className, isFullWidth, ref, ...props }: TextFieldProps) => {
	const cssClass = classNames([
		"text-field",
		{ "text-field--full-width": isFullWidth },
		className,
	]);

	return <input type="text" className={cssClass} ref={ref} {...props} />;
};
TextField.displayName = "TextField";
